import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import { trace } from 'owa-trace';

export default function getRoutingKeyPrefixForSmtpAddress(): string {
    const userConfiguration = getUserConfiguration();

    // This shouldn't happen in production, but if it does we'll have a hint.
    if (!userConfiguration || !userConfiguration.SessionSettings) {
        trace.error('SessionSettings not available');
        return 'no-routing-key:';
    }

    if (userConfiguration.SessionSettings.WebSessionType === WebSessionType.Business) {
        if (isFeatureEnabled('doc-attachment-routingKeyAadSmtp')) {
            // This is documented, but not yet implemented.
            // https://substrate.microsoft.net/documentation/Develop/Authentication/Best-practices/Routing-best-practices#
            return 'SMTP:';
        } else {
            return '';
        }
    } else {
        if (isFeatureEnabled('doc-attachment-routingKeyMsa')) {
            // This is rolling out now (August 2019).
            return 'MSA:';
        } else {
            return '';
        }
    }
}
